var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[(_vm.isTransparent)?_c('img',{staticStyle:{"width":"132px"},attrs:{"src":"/static/home/logo/logo1.png"}}):_c('img',{staticStyle:{"width":"132px"},attrs:{"src":"/static/home/logo/logo2.png"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }